<template>
   <div class="contain">
     <div class="tab-box">
       <div v-for="(item,index) in $t('agencyList.lang4')" :key="item.value" class="box-dom" @click="handTab(item.value)">
        <Badge dot v-if="(item.value == 1 && total > 0) || (item.value != 1 && noticeList.length != 0)">
          <span class="tab" :class="{'active': index + 1 == tabActive}">{{ item.name }}</span>
        </Badge>
        <span v-else class="tab" :class="{'active': index + 1 == tabActive}">{{ item.name }}</span>
       </div>
     </div> 
     <!-- 消息 -->
     <div class="categoryList" v-if="tabActive == 1">
      <div class="message" v-for="(item,index) in categoryList" :key="index" @click="handMessage(item)">
          <Badge :dot="item.unReadCount > 0">
            <img class="message-image" :src="item.icon">
          </Badge>  
          <div class="message-content">
              <div class="message-header">
                  <div class="message-title">{{ item.title }}</div>
                  <div class="message-time">{{ item.latestTime }}</div>
              </div>
              
              <div class="message-desc" ><span v-if="item.unReadCount">[{{item.unReadCount}}{{ $t('agencyList.lang6') }}]</span> {{ item.eventTypeTitle }}</div>
          </div>
      </div>
      <div class="empty" v-if="!isMessageLoading && categoryList.length === 0">
          <img src="../../../assets/images/app-pages/recordEmpty.png" class="icon">
          {{ $t("public.contentText[1]") }}
      </div>
     </div>
     <!-- 待办 -->
     <div class="notice-box" v-else>
       <div class="notice-list" v-for="(item,index) in noticeList" :key="index" @click="handJump(item)">
          <div class="content">
            <img src="../../../assets/images/app-pages/notice_icon.png" class="notice-icon" />{{ item.title }}
          </div>
          <div class="btn-box">
            <div class="btn">
              {{ item.name }}
            </div>
          </div>
       </div>
       <div class="empty" v-if="!isLoading && noticeList.length === 0">
          <img src="../../../assets/images/app-pages/recordEmpty.png" class="icon">
          {{ $t("public.contentText[1]") }}
      </div>
     </div>

    <!--  邮箱发送   -->
     <van-dialog
       v-model="isShowOpenDialog"
       :show-confirm-button="false"
       :showCancelButton="false"
       class="email-open-dialog"
     >
       <div class="dialog-main">
         <div class="dialog-title">
            {{ $t('agencyList.lang0') }}
            {{ userEmail }},
           {{ $t('agencyList.lang1') }}
         </div>
         <p class="text">
           {{ $t('agencyList.lang2') }}
           <span class="rest-send" @click="sendEmail">{{ $t('agencyList.lang3') }}</span>
         </p>
         <div class="foot-dia-btn">
           <div class="dia-btn" @click="isShowOpenDialog = false">{{ $t("transferInto.lang8") }}</div>
         </div>
       </div>
     </van-dialog>
   </div>
</template>

<script>
import { Badge, Dialog, Toast, Empty } from "vant";
import { getBrowser } from "@/utils/browser";
import newNotice from '@/assets/images/newNotice.png'
import serviceIcon from '@/assets/images/serviceIcon.png'
export default {
  components: { Badge, [Dialog.Component.name]: Dialog.Component, Empty },
  data() {
    return {
      noticeList: [],
      isShowOpenDialog: false,
      userEmail: null,
      tabActive: 1, // 默认值 1，可能被路由参数覆盖
      categoryList: [],
      total: 0,
      isLoading: true, // 添加loading状态
      isMessageLoading: true // 添加消息列表loading状态
    };
  },
  created() {
    // 从路由参数中获取 type，并赋值给 tabActive，若无则使用默认值 1
    const routeType = Number(this.$route.query.type);
    this.tabActive = isNaN(routeType) ? 1 : routeType;

    this.init();
    this.getNoticeList();
    this.$JsBridge.registerHandler("showWebView", () => {
      this.getNoticeList();
    });
  },
  methods: {
    handTab(index) {
      this.tabActive = index;
    },
    init() {
      // 默认值
      const userInfo = localStorage.getItem('userInfo')
      const userInfoObj = userInfo ? JSON.parse(userInfo) : {}
      this.userEmail = userInfoObj.email || ''
      this.user_id = userInfoObj.user_id || ''
      this.getUnreadMessage()
    },
    getNoticeList() {
      this.isLoading = true;
      this.$apis.getAgencyLists().then(res => {
        if (res) {
          const { lists } = res
          this.noticeList = lists
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      })
    },
    handJump(item) {
      const urlDetail = JSON.parse(item.jump_url) || { }
      if (urlDetail) {
        if (urlDetail.type == 1) {
          const browser = getBrowser();
          const isAPP = browser.isApp;
          if (isAPP) {
            this.$JsBridge.callHandler('jumpPage', {
              type: 1,
              url: urlDetail.url,
            })
          } else {
            window.location.href = urlDetail.url
          }
        }
        else if (urlDetail.type == 2) {
          this.isShowOpenDialog = true
        }
      }
    },

    sendEmail() {
      this.isShowOpenDialog = false
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      const params = {
        key: 1,
        captcha: 1,
        email: this.userEmail,
        type: 0
      }
      this.$apis.bindEmail(params).then(res => {
        if (res) {
          Toast(this.$t('agencyList.lang5'))
          setTimeout(() => {
            toastLoading.clear()
          }, 1000)
        }
      })
    },
    getUnreadMessage() {
      this.isMessageLoading = true;
      this.$apis.getUnreadMessage({ source: 'int_futuresapp', userId: this.user_id, noticeType: [6] }).then(res => {
        if (res.infos && res.infos.length > 0) {
          res.infos.forEach(item => {
            // 活动推送
            if (item.noticeType == 6) {
              this.categoryList.push({ icon: newNotice, title: this.$t('agencyList.lang7'), ...item })
            } 
            // 服务消息
            else if (item.noticeType == 4) {
              this.categoryList.push({ icon: serviceIcon, title: this.$t('agencyList.lang7'), ...item })
            }
            this.total = res.total
          })
        }
        this.isMessageLoading = false;
      }).catch(() => {
        this.isMessageLoading = false;
      })
    },
    handMessage(item) {
      this.$router.push({
        path: '/app-pages/message',
        query: { noticeType: item.noticeType }
      })
    }
  }
}
</script>

<style scoped lang="less">
   .contain {
     .tab-box{
       margin: 28px 32px;
       display: flex;
       .box-dom{
        margin-right: 60px;
         .tab{
           position: relative;
           font-size: 32px;
           font-weight: 500;
           color: #17161c;
         }
         .active:after{
           content: "";
           position: absolute;
           left: 0;
           bottom: 0;
           width: 100%;
           height: 4px;
           top: 56px;
           background-color: #0F0F2F;
           border-radius: 10px;
         }
       }
     }
     .empty {
        // margin: 100px 0;
        text-align: center;
        font-size: 28px;
        color: #999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 50%;
        top: 36%;
        transform: translate(-50%, -36%);
        .icon {
          width: 246px;
          height: 248px;
        }
      }
     .notice-box{
       margin: 56px 32px;
       .notice-list{
         margin-bottom: 32px;
         min-height: 148px;
         border-bottom: 1px solid #f3f3f3;
         padding-bottom: 17px;
         .content{
           .notice-icon{
             width: 40px;
             height: 40px;
             object-fit: contain;
             vertical-align: sub;
             padding-right: 10px;
           }
           font-size: 32px;
           font-weight: 500;
           color: #17161c;
         }
         .btn-box{
           float: right;
           margin-top: 26px;
           .btn{
             height: 60px;
             background: rgba(23,22,28,0.04);
             border-radius: 200px;
             padding-left: 28px;
             padding-right: 28px;
             text-align: center;
             line-height: 60px;
             font-weight: 500;
           }
         }
       }
     }
     @supports (-webkit-touch-callout: none) {
       .btn-box {
         .btn{
           padding-top: 2px;
           box-sizing: border-box;
         }
       }
     }
     /deep/ .van-badge--fixed{
      //  left: 50px;
     }
     .email-open-dialog{
       .dialog-main {
         background: #ffffff;
         border-radius: 32px;

         .dialog-title {
           text-align: center;
           margin-top: 26px;
           padding-left: 20px;
           padding-right: 20px;
           font-size: 36px;
           font-weight: 600;
           color: #17161c;
         }

         .text {
           font-size: 32px;
           font-weight: 400;
           text-align: center;
           color: #747377;
           margin-top: 18px;
           line-height: 40px;
           padding-left: 32px;
           padding-right: 32px;
           .rest-send{
             color: #328CF4;
           }
         }
         .foot-dia-btn {
           margin-top: 36px;
           .dia-btn {
             width: 85%;
             margin: 0 auto;
             height: 104px;
             text-align: center;
             background: #17161C;
             font-size: 28px;
             color: #ffffff;
             font-weight: 500;
             line-height: 104px;
             border-radius: 200px;
             font-size: 28px;
           }
         }
       }
     }
   }
   /deep/ .van-badge--dot{
     background-color: #FD2626;
     border: 0px;
   }
   .black-theme{
     .tab-box{
       .box-dom{
         .tab{
           color: #FFFFFF;
         }
         .tab:after{
           background: #ffffff;
         }
       }
     }
     .notice-box{
       .notice-list{
         border-bottom-color: #323442;
         .content{
           color: #FFFFFF;
         }
         .btn-box{
           .btn{
             background: #8E92A3;
             color: #ffffff;
           }
         }
       }
     }
     .email-open-dialog{
       background: #1B1C24;
       .dialog-main{
         background: #1B1C24;
         .dialog-title{
           color: #ffffff;
         }
         .text{
           color: #9D9D9F;
         }
         .dia-btn{
           background: #377CFB !important;
         }
       }
     }
     .message {
      border-bottom: 1px solid #323442;
     }
     .message-content {
      .message-title {
        color: white;
      }
      .message-time {
        color: white;
      }
      .message-desc {
        color: #9D9D9F;
      }
     }
   }
   .categoryList {
    margin: 0px 40px;
   }
   .message {
     display: flex;
     align-items: center;
     padding: 30px 0px;
     border-bottom: 1px solid #eee;
     /deep/ .van-badge--dot {
      left: 74px !important;
    }
    /deep/ .van-badge__wrapper {
      display: flex;
      align-items: center;
    }
     &-image {
       width: 96px;
       height: 96px;
       object-fit: contain;
       margin-right: 30px;
     }
     
     &-content {
       flex: 1;
       display: flex;
       flex-direction: column;
       margin-top: 8px;
       width: 0; 
     }
     
     &-header {
       display: flex;
       justify-content: space-between;
       align-items: center;
     }
     
     &-title {
       font-size: 32px;
       line-height: 32px;
       font-weight: 500;
       color: #17161c;
     }
     
     &-time {
       font-size: 28px;
       line-height: 28px;
       color: #747377;
     }
     
     &-desc {
      width: 100%;
       font-size: 28px;
       line-height: 36px;
       color: #17161C;
       margin-top: 14px;
       overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-shrink: 0; // 防止内容被压缩
     }
   }
   .invisible {
     visibility: hidden;
   }
</style>
